module.exports = {
  attach: function(response) {
    var $checkoutPage = $('#checkout-main');
    if ($checkoutPage.is('*')) {
      const { gtmData: { nextStep } = {} } = response || {};
      var products = $('#gtm-checkout-products').attr('data-gtm-products');
      $('body').trigger('gtm:eec:checkout', [products, nextStep]);
      $('body').trigger('gtm:ga4:checkout', [products, nextStep]);
    }
  }
}